import React from 'react';
import OperationPage from '../components/MobileDailyOperation/Operations/OperationPage';

const OperationGrid = ({ selectedDate }) => {
  return (
    <div>
      <OperationPage selectedDate={selectedDate} /> {/* selectedDate를 OperationPage 컴포넌트로 전달 */}
    </div>
  );
};

export default OperationGrid;
